export enum EMaterialsType {
  CATALOG = "CATALOG",
  PERSONAL = "PERSONAL",
}
